import React from 'react';
import { Menu, Label, Icon } from 'semantic-ui-react';
import './ThreadSelector.css';

const ThreadSelector = ({
  threads = [],
  activeThreadId,
  onThreadChange,
  orientation = 'horizontal'
}) => {
  if (threads.length <= 1) return null;

  const getThreadIcon = (threadId) => {
    if (!threadId || threadId === 'general') return 'comments';
    if (threadId.startsWith('recording_submission_')) return 'microphone';
    if (threadId.startsWith('opportunity_')) return 'briefcase';
    if (threadId.startsWith('application_')) return 'file alternate';
    if (threadId.startsWith('variation-') || threadId.startsWith('variation_')) return 'music';
    return 'list';
  };

  const isVertical = orientation === 'vertical';

  // Horizontal: Semantic's "pointing secondary" pill-style menu (used in header).
  // Vertical: Semantic's "vertical fluid" stacked menu (used in the new side pane).
  const menuProps = isVertical
    ? { vertical: true, fluid: true, className: 'thread-menu thread-menu-vertical' }
    : { pointing: true, secondary: true, className: 'thread-menu' };

  return (
    <div className={`thread-selector${isVertical ? ' thread-selector-vertical' : ''}`}>
      <Menu {...menuProps}>
        {threads.map((thread) => (
          <Menu.Item
            key={thread.id}
            name={thread.id}
            active={activeThreadId === thread.id}
            onClick={() => onThreadChange(thread.id)}
            className="thread-menu-item"
          >
            <Icon name={getThreadIcon(thread.id)} />
            <span className="thread-name">{thread.name}</span>
            {thread.unreadCount > 0 && (
              <Label circular color="red" size="mini" className="thread-unread">
                {thread.unreadCount}
              </Label>
            )}
          </Menu.Item>
        ))}
      </Menu>
    </div>
  );
};


export default ThreadSelector;
